import { render, staticRenderFns } from "./DreieckGSE.vue?vue&type=template&id=5cec1977&"
import script from "./DreieckGSE.vue?vue&type=script&lang=js&"
export * from "./DreieckGSE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports